import { render } from "./richtext.vue?vue&type=template&id=0c866584&scoped=true"
import script from "./richtext.vue?vue&type=script&lang=js"
export * from "./richtext.vue?vue&type=script&lang=js"

import "./richtext.vue?vue&type=style&index=0&id=0c866584&scoped=true&lang=css"
import "./richtext.vue?vue&type=style&index=1&id=0c866584&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c866584"]])

export default __exports__